import { render } from "./AdvisorsList.vue?vue&type=template&id=8a363eda&scoped=true"
import script from "./AdvisorsList.vue?vue&type=script&lang=js"
export * from "./AdvisorsList.vue?vue&type=script&lang=js"

import "./AdvisorsList.vue?vue&type=style&index=0&id=8a363eda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a363eda"]])

export default __exports__